import React from 'react';
import PropTypes from 'prop-types';
import {Route, Switch, Redirect, withRouter} from 'react-router-dom';
import {map} from 'lodash';
import {getSteps} from './constants';
import PartnerLogoHeader from 'shared/components/partner-logo-header/partner-logo-header';
import FooterWithSteps from 'shared/components/footer-with-steps';
import styles from './styles.module.scss';

class EducationOnboarding extends React.Component {
  state = {
    stepPaths: [],
    steps: {},
  };

  static propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      params: PropTypes.shape({
        page: PropTypes.string,
      }).isRequired,
    }).isRequired,
    getStudentInfo: PropTypes.func.isRequired,
    collegeSatisfaction: PropTypes.string,
    goals: PropTypes.array,
    setOnboardingCompletedAt: PropTypes.func.isRequired,
    fetchCollegeFields: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const steps = getSteps(true);

    this.setState({stepPaths: Object.keys(steps), steps});

    this.props
      .getStudentInfo()
      .then(({student}) =>
        this.props.fetchCollegeFields(student.currentInstitution.schoolId, [
          'logo',
          'redeemableTerm',
        ])
      );
  }

  handleNext = (currentStep) => () => {
    if (currentStep < this.state.stepPaths.length - 1) {
      this.props.history.push(`/education/${this.state.stepPaths[currentStep + 1]}`);
    } else {
      this.completeOnboarding();
    }
  };

  completeOnboarding = () => {
    const {history, setOnboardingCompletedAt} = this.props;

    setOnboardingCompletedAt().then(() => history.push('/scholarships'));
  };

  handleBack = (currentStep) => () => {
    this.props.history.push(`/education/${this.state.stepPaths[currentStep - 1]}`);
  };

  primaryText = (currentStep) => {
    let text = 'Next';

    if (this.state.stepPaths[currentStep] === 'goals' && this.props.goals.length < 1) {
      text = 'Select 1';
    }

    return text;
  };

  primaryActionDisabled = (currentStep) => {
    let disabled = false;

    if (
      (this.state.stepPaths[currentStep] === 'check-in' && !this.props.collegeSatisfaction) ||
      (this.state.stepPaths[currentStep] === 'goals' && this.props.goals.length < 1)
    ) {
      disabled = true;
    }

    return disabled;
  };

  render() {
    const currentStep = Math.max(this.state.stepPaths.indexOf(this.props.match.params.page), 0);
    return (
      <div className={styles.ssContainer}>
        <PartnerLogoHeader />
        <Switch>
          {map(this.state.stepPaths, (path) => (
            <Route key={path} path={`/education/${path}`} component={this.state.steps[path]} />
          ))}
          <Redirect path="*" to={`/education/${this.state.stepPaths[0]}`} />
        </Switch>
        <FooterWithSteps
          currentStepIndex={currentStep}
          numberOfSteps={this.state.stepPaths.length}
          onBack={currentStep > 0 ? this.handleBack(currentStep) : null}
          onNext={this.handleNext(currentStep)}
          primaryText={this.primaryText(currentStep)}
          primaryActionDisabled={this.primaryActionDisabled(currentStep)}
        />
      </div>
    );
  }
}

export default withRouter(EducationOnboarding);
